<template>
    <div class="page">
        <answer-header type="back"></answer-header>
        <img class="logo" src="../assets/logo.png">
        <div class="txtcenter">
            <p class="fz46">{{id}}</p>
            <p class="mt10">ဖုန်းနံပါတ်: {{mobile}}</p>
            <p class="mt10">လတ်တလောအဆင့်: {{score}}</p>
        </div>
        <div class="unsub-text" v-html="content"></div>
        <div @click="_goUnsubs" class="btn btn-blue btn-block">အဖွဲ့ဝင်အဖြစ်မှထွက်ခြင်း</div>
    </div>
</template>

<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Unsub',
    components: {answerHeader},
    data(){
        return {
            id: '',
            mobile: '',
            score: 0,
            ranking: 0,
            content: ''
        }
    },
    computed: {
        ...mapState(['lang','langMap'])
    },
    created(){
        this._fetchUserInfo();
        this._fetchContent();
    },
    methods: {
        _fetchUserInfo(){
            Utils.$ajax({
                url: '/user/info',
            }).done(res=>{
                if(res.code!=0){
                    this.$toast(res.msg);
                    return;
                }
                this.score = res.data.score;
                this.mobile = res.data.mobile;
                this.ranking = res.data.ranking;
                this.id = res.data.uuid;
            })
        },
        _fetchContent: function(){
            Utils.$ajax({
                url: '/share/unsub',
            }).done(res =>{
                if (res.code != 0){
                    this.$toast(res.msg);
                    return;
                }
                this.content = res.data.content;
            })
        },
        _goUnsubs(){
            let msg = 'အကောင်းဆုံးဆုတွေ ရရှိဖို့အတွက် အဖွဲ့ဝင်အဖြစ်မှ နှုတ်ထွက်မသွားစေချင်ပါဘူး';
            this.$messagebox.confirm(msg, 'tips', {confirmButtonText:'OK', cancelButtonText:'Cancel'}).then(action=>{
                if(action === 'confirm'){
                  this.requestUnsub();
                  localStorage.clear();
                  this.$router.push('login');
                }
            });
        },
        requestUnsub(){
          Utils.$ajax({
            type: 'post',
            url: '/user/unsub',
            data: {},
          }).done(res=>{

          })
        }
    }
}
</script>

<style lang="scss" scoped>
    .page{
        color: #fff;
    }
    .fz46{
        font-size: rem(46);
    }
    .unsub-text{
        margin: rem(60) auto rem(30);
        height: rem(550);
        overflow-y: scroll;
        p{
            margin: rem(20) 0;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Unsub.vue